const Type = {
    ICON: 'icon',
    SVG: 'svg',
};

export default Type;
